/* eslint-disable */
import { useEffect, useMemo, useRef } from 'react';
import { motion } from 'framer-motion';
import { useHistory } from 'react-router-dom';
import { Button, TablePagination } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { NumberParam, NumericArrayParam, StringParam, useQueryParams, withDefault } from 'use-query-params';
import { DateTime } from 'luxon';
import useSWR from 'swr';
import { Header, Container, ExportReportWrapper } from '../../styles/shared/styles';
import IndicationManagerReportTableList from '../../components/InidicationReportGerVeicTableList';
import DatePeriodFilter from '../../components/InidicationReportGerVeicTableList/Filter';
import SummaryReport from '../../components/InidicationReportGerVeicTableList/SummaryReport';
import { variantFetcher } from '../../service/SWRFetcher';
import useApp from '../../hooks/useApp';
import { excelExport } from '../../service/excel.service';
import { reportQueryOptions } from '../../utils/reportQueryParams';

const InidicationReportGerVeic = () => {
  const ref = useRef(null);
  const { setState } = useApp();
  const history = useHistory();

  const paramConfig = useMemo(
    () => ({
      date_ini: withDefault(StringParam, DateTime.now().plus({ months: -1 }).toISODate()),
      date_end: withDefault(StringParam, DateTime.now().toISODate()),
      partner_id: withDefault(NumericArrayParam, []),
      insurance_id: withDefault(NumericArrayParam, []),
      channel_id: withDefault(NumericArrayParam, []),
      inviter_id: withDefault(StringParam, ''),
      client_id: withDefault(StringParam, ''),
      client_name: withDefault(StringParam, ''),
      page: withDefault(NumberParam, 0),
      per_page: withDefault(NumberParam, 10),
      // Não são filtros: marcam que a tela veio do relatório de F&I e guardam
      // a URL de retorno com os filtros de lá.
      from: withDefault(StringParam, ''),
      fi_q: withDefault(StringParam, ''),
    }),
    []
  );

  const [filters, setFilters] = useQueryParams(paramConfig, reportQueryOptions);

  const fromFi = filters.from === 'fi';

  const handleChangePage = (event, newPage) => setFilters({ page: newPage });

  const handleChangeRowsPerPage = (event) =>
    setFilters({ page: 0, per_page: parseInt(event.target.value, 10) });

  const applyFilters = (values) => setFilters({ ...values, page: 0 });

  const backToFiReport = () => {
    history.push({ pathname: '/relatorio-indicacao-fi', search: filters.fi_q });
  };

  const listParam = (key, ids) => (ids || []).map((id) => `&${key}[]=${id}`).join('');
  const singleParam = (key, value) => (value ? `&${key}=${value}` : '');

  const queryParams = () =>
    `date_ini=${filters.date_ini}&date_end=${filters.date_end}` +
    listParam('insurance_id', filters.insurance_id) +
    listParam('partner_id', filters.partner_id) +
    listParam('channel_id', filters.channel_id) +
    singleParam('inviter_id', filters.inviter_id) +
    singleParam('client_id', filters.client_id);

  const { data, isValidating } = useSWR(
    `/leads/indicationReportGerVeic?page=${filters.page}&per_page=${filters.per_page}&${queryParams()}`,
    variantFetcher,
    { revalidateOnFocus: false }
  );

  useEffect(() => {
    setState('loading', isValidating);
  }, [isValidating]);

  useEffect(() => {
    if (filters.page || filters.per_page > 10) {
      ref?.current?.scrollIntoView({ behavior: 'smooth' });
    }
  }, [filters.page, filters.per_page, isValidating]);

  return (
    <motion.div initial={{ opacity: 0, x: -100 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: -100 }}>
      <Container style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        <Header>
          <h1>Relatório de Indicação (Concessionária)</h1>

          {fromFi && (
            <Button startIcon={<ArrowBackIcon />} onClick={backToFiReport} style={{ color: '#f26522' }}>
              Voltar ao Relatório de Indicação F&I
            </Button>
          )}
        </Header>

        <DatePeriodFilter filters={filters} setFilters={applyFilters} />

        <SummaryReport listItem={data?.summaryReport} title="Relatório de Indicação (Gerência) - Resumo" />

        {data?.summaryReport && data?.summaryReport?.length > 0 && (
          <ExportReportWrapper>
            <button
              className="button"
              onClick={() =>
                excelExport(
                  `/leads/summaryReportGerVeicExport?${queryParams()}`,
                  'resumo_relatorio_indicação_concessionaria' + DateTime.now().toFormat('dd_LL_yyyy')
                )
              }>
              Exportar
            </button>
          </ExportReportWrapper>
        )}

        <TablePagination
          ref={ref}
          component="div"
          count={data?.meta?.total || 0}
          page={filters.page}
          onPageChange={handleChangePage}
          rowsPerPage={filters.per_page}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />

        <IndicationManagerReportTableList
          listItem={data?.data}
          title="Relatório de Indicação (Gerência)"
          showInviter={!fromFi}
          showClientPhone={fromFi}
        />

        {data?.data && data?.data?.length > 0 && (
          <ExportReportWrapper>
            <button
              className="button"
              onClick={() =>
                excelExport(
                  `/leads/indicationReportGerVeicExport?${queryParams()}`,
                  'relatorio_indicação_concessionaria' + DateTime.now().toFormat('dd_LL_yyyy')
                )
              }>
              Exportar
            </button>
          </ExportReportWrapper>
        )}
      </Container>
    </motion.div>
  );
};

export default InidicationReportGerVeic;
